module.exports = __webpack_public_path__ + "static/media/yoga-banner.b82457ce.jpeg";